import React from "react";
import { Link } from "react-router-dom";

import "../../utilities.css"
import "./ButtonFlex.css";

import { scrollToTop } from "../../utilities.js";

const ButtonFlex = (
    {display = [
      {key: 1, des: "Learn more", isLocal: true, link: "/about"},
      {key: 2, des: "Contact us", isLocal: true, link: "/contact"},
      {key: 3, des: "College website", isLocal: false, link: "https://www.univ.ox.ac.uk"}
    ]}
  ) => {

  const defaultColor = ["secondary", "primary", "medgrey"];

  return (
    <div className={`ButtonFlex-container ButtonFlex-container-${display.length}`}>
      {display.map((item, idx) => {
        return (
          <React.Fragment key={item.key}>
            { item.link ? (
              <>
                { item.isLocal ? (
                  <Link 
                    onClick={item.onClick || scrollToTop} 
                    to={item.link} 
                    className={`u-b-${item.color || defaultColor[idx]}`} 
                  > 
                    {item.des} </Link>
                ) : (
                  <a 
                    href={item.link}
                    className={`u-b-${item.color || defaultColor[idx]}`}
                  >
                    {item.des}</a>
                )}
              </>
            ) : (
              <>
                { item.isSubmit ? (
                  <input 
                    className={`u-b-${item.color || defaultColor[idx]}`}
                    type="submit"
                    onClick={item.onClick}
                    key={item.key} />
                ) : (
                  <button 
                    onClick={item.onClick}
                    className={`u-b-${item.color || defaultColor[idx]}`}
                    key={item.key}>
                    {item.des}
                  </button>
                )}
              </>
            )}
          </React.Fragment>)
      })}
    </div>
  );
}
  
export default ButtonFlex;
  